import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { Listing } from 'ha/services/apiV2/types/Listing';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<Listing>('POST', `/api/v2/listing/${listingId}/copy`);

export type DuplicateListingCall = (
  listingId: number,
) => Promise<{ data: Listing }>;
